/**
 * LEORI — comportements d'interface.
 *
 * Séparé de leori-animations.js à dessein : ce fichier ne doit JAMAIS
 * court-circuiter sous `prefers-reduced-motion`. Un tiroir de navigation
 * est une fonctionnalité, pas une décoration — le couper rendrait le site
 * inutilisable pour les personnes qui ont réduit les animations.
 *
 * Fournit : ouverture/fermeture des tiroirs, piégeage de focus, Escape,
 * retour du focus à l'élément déclencheur, verrouillage du défilement.
 */
(function () {
  'use strict';

  var FOCUSABLE = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'details > summary',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  var openPanel = null;
  var lastTrigger = null;
  var scrollY = 0;

  function focusables(container) {
    var list = container.querySelectorAll(FOCUSABLE);
    var out = [];
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (el.offsetWidth || el.offsetHeight || el.getClientRects().length) out.push(el);
    }
    return out;
  }

  function lockScroll() {
    scrollY = window.pageYOffset;
    document.body.style.position = 'fixed';
    document.body.style.top = -scrollY + 'px';
    document.body.style.width = '100%';
  }

  function unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
  }

  function open(panel, trigger) {
    if (openPanel) close();

    openPanel = panel;
    lastTrigger = trigger || null;

    panel.hidden = false;
    // Un frame pour que la transition d'entrée soit prise en compte
    window.requestAnimationFrame(function () {
      panel.classList.add('is-open');
    });

    panel.setAttribute('aria-hidden', 'false');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    lockScroll();

    var f = focusables(panel);
    var first = panel.querySelector('[data-leori-autofocus]') || f[0];
    if (first) first.focus();
  }

  function close() {
    if (!openPanel) return;

    var panel = openPanel;
    openPanel = null;

    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');

    var triggers = document.querySelectorAll('[aria-controls="' + panel.id + '"]');
    for (var i = 0; i < triggers.length; i++) triggers[i].setAttribute('aria-expanded', 'false');

    unlockScroll();

    var done = function () {
      panel.hidden = true;
      panel.removeEventListener('transitionend', done);
    };

    // Repli si aucune transition ne se déclenche (reduced motion, navigateur ancien)
    panel.addEventListener('transitionend', done);
    window.setTimeout(done, 400);

    if (lastTrigger) {
      lastTrigger.focus();
      lastTrigger = null;
    }
  }

  /* Ouverture / fermeture par délégation : fonctionne aussi sur le contenu
     injecté plus tard par l'éditeur de thème. */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-leori-open]');
    if (opener) {
      var panel = document.getElementById(opener.getAttribute('data-leori-open'));
      if (panel) {
        e.preventDefault();
        if (panel === openPanel) close();
        else open(panel, opener);
      }
      return;
    }

    if (e.target.closest('[data-leori-close]')) {
      e.preventDefault();
      close();
      return;
    }

    // Clic sur le voile
    if (openPanel && e.target.hasAttribute && e.target.hasAttribute('data-leori-overlay')) {
      close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!openPanel) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      close();
      return;
    }

    if (e.key !== 'Tab') return;

    // Piégeage du focus
    var f = focusables(openPanel);
    if (!f.length) return;

    var first = f[0];
    var last = f[f.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  /* ------------------------------------------------------------------
     Quantités du tiroir panier.

     Trois chemins, du meilleur au dernier recours :
     · l'API panier de Shopify met la ligne à jour, puis l'API de rendu de
       section rend l'en-tête à neuf — le tiroir reste ouvert, rien ne
       clignote ;
     · si l'un des deux appels échoue, le formulaire part en POST vers /cart :
       la page recharge, mais la quantité demandée est bien prise ;
     · sans JavaScript du tout, les boutons « − » et « + » n'existent pas à
       l'écran (CSS `.no-js`) et « Mettre à jour le panier » prend le relais.

     Ce comportement vit ici et non dans leori-animations.js : modifier une
     quantité est une fonctionnalité, pas une décoration.
     ------------------------------------------------------------------ */
  (function () {
    var occupe = false;

    /* On ne remplace que le CORPS du panneau : la classe `is-open` et
       l'attribut `hidden` vivent sur le panneau lui-même, et les écraser
       refermerait le tiroir à chaque clic sur « + ». */
    function remplacer(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var neuf = doc.getElementById('leori-cart');
      var ancien = document.getElementById('leori-cart');
      if (!neuf || !ancien) return false;

      var corpsNeuf = neuf.querySelector('.leori-panel__body');
      var corps = ancien.querySelector('.leori-panel__body');
      if (!corpsNeuf || !corps) return false;

      /* Ce qui avait le focus va disparaître avec l'ancien corps. On note son
         identifiant pour le rendre au même endroit : sans cela le focus
         retombe sur <body>, le piégeage n'a plus de prise et la touche Tab
         sort du tiroir. */
      var actif = document.activeElement;
      var repere = actif && corps.contains(actif) ? actif.getAttribute('aria-controls') || actif.id : null;

      corps.replaceWith(corpsNeuf);

      var reprise = repere ? corpsNeuf.querySelector('[aria-controls="' + repere + '"], #' + repere) : null;
      var aFocaliser = reprise || corpsNeuf.querySelector('[data-leori-close]');
      if (aFocaliser) aFocaliser.focus();

      /* La pastille du header porte le nombre d'articles : elle se met à jour
         avec le reste, sans toucher à `aria-expanded`, qui décrit l'état du
         tiroir et non son contenu. */
      var iconeNeuve = doc.querySelector('[data-leori-open="leori-cart"]');
      var icone = document.querySelector('[data-leori-open="leori-cart"]');
      if (iconeNeuve && icone) {
        icone.innerHTML = iconeNeuve.innerHTML;
        icone.setAttribute('aria-label', iconeNeuve.getAttribute('aria-label') || '');
      }

      return true;
    }

    function changer(champ) {
      if (occupe) return;
      var form = champ.form;
      var ligne = Number(champ.getAttribute('data-leori-line'));
      var quantite = Number(champ.value);
      if (!ligne || quantite < 0 || isNaN(quantite)) return;

      /* Hors du tiroir — c'est-à-dire sur la page /cart — il n'y a rien à
         rafraîchir en place : la page ENTIÈRE affiche le panier, et la rendre
         à neuf par l'API de section ne mettrait à jour que l'en-tête. Le
         formulaire part donc directement, et Shopify renvoie la page à jour. */
      if (!champ.closest('#leori-cart')) {
        if (form) form.submit();
        return;
      }

      occupe = true;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: ligne, quantity: quantite })
      })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(function () {
          /* L'identifiant de section est porté par le panneau : « header » en
             dur ne correspondait à rien côté Shopify, qui nomme ses sections
             « sections--<id>__header ». L'appel renvoyait null, le rendu à
             neuf échouait, et on retombait à chaque fois sur le rechargement
             complet de la page. */
          var panneau = document.getElementById('leori-cart');
          var section = panneau && panneau.getAttribute('data-leori-section');
          if (!section) throw new Error('section inconnue');
          return fetch(window.location.pathname + '?sections=' + encodeURIComponent(section));
        })
        .then(function (r) { if (!r.ok) throw new Error('section'); return r.json(); })
        .then(function (data) {
          /* La réponse est indexée par l'identifiant de section, quel qu'il
             soit : on prend la seule valeur qu'elle contient. */
          var fragment = data[Object.keys(data)[0]];
          if (!fragment || !remplacer(fragment)) throw new Error('markup');
          occupe = false;
        })
        .catch(function () {
          occupe = false;
          if (form) form.submit();
        });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-leori-qty]');
      if (!btn) return;
      e.preventDefault();

      var champ = document.getElementById(btn.getAttribute('aria-controls'));
      if (!champ) return;

      var suivant = (parseInt(champ.value, 10) || 0) + Number(btn.getAttribute('data-leori-qty'));
      if (suivant < 0) suivant = 0;
      champ.value = suivant;
      changer(champ);
    });

    /* Une quantité tapée au clavier compte autant qu'un clic sur « + ». */
    document.addEventListener('change', function (e) {
      var champ = e.target.closest && e.target.closest('[data-leori-qty-input]');
      if (champ) changer(champ);
    });
  })();

  /* ------------------------------------------------------------------
     Header transparent → ivoire.
     Ce comportement vit ici et non dans leori-animations.js : ce dernier
     se coupe entièrement sous `prefers-reduced-motion`, et un header
     resté transparent au milieu de la page serait illisible.
     ------------------------------------------------------------------ */
  (function () {
    var header = document.querySelector('[data-leori-header]');
    if (!header || header.className.indexOf('leori-header--overlay') === -1) return;

    var ticking = false;

    function paint() {
      ticking = false;
      header.classList.toggle('is-solid', window.pageYOffset > 4);
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(paint);
    }, { passive: true });

    paint();
  })();

  /* ------------------------------------------------------------------
     Flèches des rails produit.
     Ce comportement vit ici et non dans leori-animations.js : faire défiler
     une rangée est une fonctionnalité, pas une décoration.
     ------------------------------------------------------------------ */
  function initRails() {
    var rails = document.querySelectorAll('[data-leori-rail]');

    for (var i = 0; i < rails.length; i++) {
      (function (wrap) {
        var track = wrap.querySelector('[data-leori-rail-track]');
        var nav = wrap.querySelector('[data-leori-rail-nav]');
        if (!track || !nav || nav.getAttribute('data-ready')) return;

        var prev = nav.querySelector('[data-leori-rail-prev]');
        var next = nav.querySelector('[data-leori-rail-next]');

        function overflows() {
          return track.scrollWidth - track.clientWidth > 4;
        }

        function sync() {
          if (!overflows()) {
            nav.hidden = true;
            return;
          }
          nav.hidden = false;
          prev.disabled = track.scrollLeft <= 4;
          next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
        }

        function step(direction) {
          var card = track.firstElementChild;
          var by = card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
          track.scrollBy({ left: by * direction, behavior: 'smooth' });
        }

        prev.addEventListener('click', function () { step(-1); });
        next.addEventListener('click', function () { step(1); });
        track.addEventListener('scroll', sync, { passive: true });
        window.addEventListener('resize', sync);

        nav.setAttribute('data-ready', '1');
        sync();
      })(rails[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRails);
  } else {
    initRails();
  }

  document.addEventListener('shopify:section:load', initRails);

  /* ------------------------------------------------------------------
     Étapes « Comment ça marche ».
     Ce comportement vit ici : sélectionner une étape au clic ou au clavier
     doit rester possible même quand les animations sont réduites. Seul
     l'enchaînement automatique s'arrête dans ce cas.
     ------------------------------------------------------------------ */
  function initSteps() {
    var blocks = document.querySelectorAll('[data-leori-steps]');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    for (var i = 0; i < blocks.length; i++) {
      (function (root) {
        if (root.getAttribute('data-ready')) return;

        var items = root.querySelectorAll('[data-leori-step]');
        var slides = root.querySelectorAll('[data-leori-step-media]');
        if (items.length < 2) return;

        var delay = (Number(root.getAttribute('data-leori-steps-delay')) || 5) * 1000;
        var current = 0;
        var timer = null;

        root.style.setProperty('--leori-step-delay', delay + 'ms');

        function show(index) {
          current = (index + items.length) % items.length;
          for (var k = 0; k < items.length; k++) {
            items[k].classList.toggle('is-active', k === current);
            if (slides[k]) {
              slides[k].classList.toggle('is-active', k === current);
              slides[k].setAttribute('aria-hidden', k === current ? 'false' : 'true');
            }
          }
        }

        function play() {
          if (reduced) return;
          stop();
          timer = window.setInterval(function () { show(current + 1); }, delay);
        }

        function stop() {
          if (timer) { window.clearInterval(timer); timer = null; }
        }

        for (var b = 0; b < items.length; b++) {
          (function (index) {
            var btn = items[index].querySelector('[data-leori-step-btn]');
            if (!btn) return;
            btn.addEventListener('click', function () { show(index); play(); });
            btn.addEventListener('focus', function () { show(index); stop(); });
            /* La frise répond à la souris : survoler une étape la sélectionne
               et suspend l'avance automatique, qui reprend à la sortie de la
               section. Sur un écran tactile, `mouseenter` n'est pas émis et
               le clic reste le seul chemin — c'est voulu. */
            btn.addEventListener('mouseenter', function () { show(index); stop(); });
          })(b);
        }

        /* On ne fait tourner que ce qui est à l'écran. */
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries[0].isIntersecting ? play() : stop();
          }, { threshold: 0.25 }).observe(root);
        } else {
          play();
        }

        root.addEventListener('mouseenter', stop);
        root.addEventListener('mouseleave', play);

        root.setAttribute('data-ready', '1');
        show(0);
      })(blocks[i]);
    }
  }


  /* ----------------------------------------------------------------------
     Recherche prédictive.

     Le balisage vient de Shopify, pas d'ici : on appelle l'API de rendu de
     section et on insère ce qu'elle renvoie. Fabriquer le HTML en JavaScript
     aurait dupliqué la carte produit et l'aurait laissée diverger.

     Sans JavaScript, le formulaire part vers /search et rien n'est perdu :
     ce module n'est qu'une accélération.
     ---------------------------------------------------------------------- */
  function initPredictive() {
    var champ = document.querySelector('[data-leori-predict-input]');
    var zone = document.querySelector('[data-leori-predict]');
    if (!champ || !zone || champ.dataset.predictReady === '1') return;
    champ.dataset.predictReady = '1';

    var MINI = 3;      /* en deca, le bruit depasse le service */
    var ATTENTE = 220; /* on laisse finir de taper avant d interroger */
    var minuteur = null;
    var enCours = null;
    var dernier = '';

    function vider() {
      zone.innerHTML = '';
      zone.hidden = true;
      champ.setAttribute('aria-expanded', 'false');
    }

    function chercher(terme) {
      /* Une requete plus ancienne qui reviendrait apres une plus recente
         afficherait un resultat perime : on annule avant de relancer. */
      if (enCours) enCours.abort();
      enCours = new AbortController();

      var url = '/search/suggest?q=' + encodeURIComponent(terme) +
                '&resources[type]=product&resources[limit]=6' +
                '&section_id=leori-predictive';

      fetch(url, { signal: enCours.signal })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var res = doc.querySelector('[data-leori-predict-results]');
          if (!res) return vider();
          zone.innerHTML = res.innerHTML;
          zone.hidden = false;
          champ.setAttribute('aria-expanded', 'true');
        })
        .catch(function (e) {
          /* Une annulation n est pas une panne : on ne vide pas l affichage,
             sinon les resultats clignotent a chaque frappe. */
          if (e && e.name === 'AbortError') return;
          vider();
        });
    }

    champ.addEventListener('input', function () {
      var terme = champ.value.trim();
      if (minuteur) window.clearTimeout(minuteur);
      if (terme.length < MINI) { dernier = ''; return vider(); }
      if (terme === dernier) return;
      dernier = terme;
      minuteur = window.setTimeout(function () { chercher(terme); }, ATTENTE);
    });

    function items() {
      return Array.prototype.slice.call(zone.querySelectorAll('[data-leori-predict-item]'));
    }

    function deplacer(sens) {
      var liste = items();
      if (!liste.length) return;
      var i = liste.indexOf(document.activeElement);
      var suivant;
      if (i === -1) {
        suivant = sens > 0 ? liste[0] : liste[liste.length - 1];
      } else {
        suivant = liste[i + sens];
        /* Au-dela du dernier on redescend dans le champ : une boucle infinie
           enferme, le retour au champ laisse corriger sa saisie. */
        if (!suivant) { champ.focus(); return; }
      }
      suivant.focus();
    }

    function clavier(e) {
      if (zone.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); deplacer(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); deplacer(-1); }
      else if (e.key === 'Escape') { e.preventDefault(); vider(); champ.focus(); }
    }

    champ.addEventListener('keydown', clavier);
    zone.addEventListener('keydown', clavier);

    champ.setAttribute('role', 'combobox');
    champ.setAttribute('aria-expanded', 'false');
    champ.setAttribute('aria-controls', zone.id || 'leori-predict');
    champ.setAttribute('aria-autocomplete', 'list');
  }


  /* ------------------------------------------------------------------
     Copie du code promo
     ------------------------------------------------------------------
     Le code reste du texte réel dans la page : le bouton n'est qu'un
     raccourci. `navigator.clipboard` n'existe qu'en contexte sécurisé et
     peut être refusé — dans ce cas on sélectionne le code pour que la
     cliente puisse le copier elle-même, plutôt que de ne rien faire.
  */
  function initCopie() {
    var boutons = document.querySelectorAll('[data-leori-copy]');
    if (!boutons.length) return;

    Array.prototype.forEach.call(boutons, function (btn) {
      var etat = document.getElementById(btn.getAttribute('aria-describedby'));
      var minuteur;

      function annoncer(msg, copie) {
        if (etat) etat.textContent = msg;
        btn.classList.toggle('is-copied', !!copie);
        clearTimeout(minuteur);
        minuteur = setTimeout(function () {
          btn.classList.remove('is-copied');
          if (etat) etat.textContent = 'Copier le code';
        }, 3000);
      }

      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-leori-copy') || '';

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(function () {
            annoncer('Code ' + code + ' copié.', true);
          }, selectionner);
        } else {
          selectionner();
        }

        function selectionner() {
          var cible = btn.querySelector('.leori-promo__codeval');
          if (!cible || !window.getSelection) {
            annoncer('Code ' + code + '. Recopiez-le au moment de la commande.', false);
            return;
          }
          var plage = document.createRange();
          plage.selectNodeContents(cible);
          var sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(plage);
          annoncer('Code ' + code + ' sélectionné, à copier.', false);
        }
      });
    });
  }

  function demarrer() {
    initSteps();
    initCopie();
    initPredictive();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }

  document.addEventListener('shopify:section:load', demarrer);

  /* L'éditeur de thème ferme les panneaux quand une section est rechargée. */
  document.addEventListener('shopify:section:load', close);
  document.addEventListener('shopify:section:select', close);
})();
